"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderType = exports.OrderSelector = exports.ButtonType = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _OrderListPopup = require("../OrderListPopup");
var _useTracking = require("../../hooks/useTracking");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var OrderType;
exports.OrderType = OrderType;
(function (OrderType) {
  OrderType["food"] = "food";
})(OrderType || (exports.OrderType = OrderType = {}));
var ButtonType;
exports.ButtonType = ButtonType;
(function (ButtonType) {
  ButtonType[ButtonType["Link"] = 1] = "Link";
  ButtonType[ButtonType["Primary"] = 2] = "Primary";
})(ButtonType || (exports.ButtonType = ButtonType = {}));
var prefixCls = (0, _getPrefixCls.getPrefixCls)('order-selector');
var OrderSelector = function OrderSelector(props) {
  var _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    _props$buttonText = props.buttonText,
    buttonText = _props$buttonText === void 0 ? '' : _props$buttonText,
    wrapperStyle = props.wrapperStyle,
    panelTitleText = props.panelTitleText,
    showLoading = props.showLoading,
    onLoadMore = props.onLoadMore,
    loadMoreParams = props.loadMoreParams,
    limit = props.limit,
    orderCardType = props.orderCardType,
    onClosePopup = props.onClosePopup,
    groupOrderText = props.groupOrderText,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$buttonType = props.buttonType,
    buttonType = _props$buttonType === void 0 ? ButtonType.Link : _props$buttonType,
    componentTrackingData = props.componentTrackingData,
    handleSelectOrder = props.handleSelectOrder,
    isUIOptimisation = props.isUIOptimisation;
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: _objectSpread({}, props)
    }),
    tracker = _useComponentTracking.tracker,
    selectorBtnTracking = _useComponentTracking.result.selectorBtn;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showPopup = _useState2[0],
    setShowPopup = _useState2[1];
  var onClickShowOrderBtn = function onClickShowOrderBtn() {
    if (disabled) {
      return;
    }
    (selectorBtnTracking === null || selectorBtnTracking === void 0 ? void 0 : selectorBtnTracking.trackingClick) && tracker.click(selectorBtnTracking.trackingClick);
    setShowPopup(true);
  };
  var handleClosePopup = function handleClosePopup() {
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
    setShowPopup(false);
  };
  var onSelectOrder = function onSelectOrder(order) {
    // const { action } = order;
    // action &&
    //   context?.eventEmitter?.emit?.(
    //     action?.func,
    //     {
    //       text,
    //       action,
    //     },
    //     action.callback
    //   );
    handleSelectOrder === null || handleSelectOrder === void 0 ? void 0 : handleSelectOrder(order);
    setShowPopup(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)("".concat(prefixCls, "-container"), "".concat(prefixCls, "-container_").concat(buttonType), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-container-ui-optimisaton"), isUIOptimisation))
  }, /*#__PURE__*/_react.default.createElement("p", {
    style: wrapperStyle,
    className: (0, _clsx3.default)("".concat(prefixCls, "-btn-wrapper"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-btn-wrapper-ui-optimisaton"), isUIOptimisation))
  }, text, /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    onClick: onClickShowOrderBtn,
    className: disabled ? "".concat(prefixCls, "-btn_disable") : ''
  }, selectorBtnTracking === null || selectorBtnTracking === void 0 ? void 0 : selectorBtnTracking.trackingImpressionProps), " ".concat(buttonText))), /*#__PURE__*/_react.default.createElement(_OrderListPopup.OrderListPopup, {
    active: showPopup,
    panelTitleText: panelTitleText,
    showLoading: showLoading,
    loadMoreParams: loadMoreParams,
    limit: limit,
    onLoadMore: onLoadMore,
    groupOrderText: groupOrderText,
    orderCardType: orderCardType,
    onClosePopup: handleClosePopup,
    onSelectOrder: onSelectOrder,
    componentTrackingData: componentTrackingData,
    isUIOptimisation: isUIOptimisation
  }));
};
exports.OrderSelector = OrderSelector;